import { render, staticRenderFns } from "./PaymentRecords.vue?vue&type=template&id=031fb167&"
import script from "./PaymentRecords.vue?vue&type=script&lang=js&"
export * from "./PaymentRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports